<template>
  <div :style="`max-height: ${cardHeight}px;`" @click="selectCard()">
    <fitt-card
        class="card-hover"
        :style="`transform: translate(${index * -2}px, ${(index * -cardHeight + (-2 * index))}px); cursor: ${cards.length > 4 ? 'pointer' : 'default'};`"
        :id="'card_' + index"
        :card="card"
        :height="cardHeight"
        :width="cardWidth"
        :key="card.id"
        v-ripple="cards.length > 4"
        v-for="(card, index) in cards"
    ></fitt-card>
  </div>
</template>

<script>
import FittCard from "@/views/Tools/SecPeak/Components/FittCard";

export default {
  name: "FittCardsDeck",
  components: {
    FittCard,
  },
  props: {
    cards: {
      type: Array,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    cardHeight() {
      return this.dense ? 240 : 320;
    },
    cardWidth() {
      return this.dense ? 160 : 208;
    },
  },
  data: () => ({}),
  methods: {
    selectCard() {
      this.$emit('selectCard');

      if (this.cards.length > 4) {
        let card = this.cards.find((_, index) => index === this.cards.length - 1);
        this.$set(card, 'selected', true);
      }
    },
  },
  mounted() {
  }
}
</script>

<style scoped>
</style>